import { useRouter } from 'next/router'
import { WORKSPACE_TAB } from 'ui-components'
import { GuestList as View, PLANS } from 'ui-components'
import { useIsWorkspaceOwner } from '~workspace/hooks/useIsWorkspaceOwner'
import { useDeleteInvitedUser } from '~workspace/queries/useDeleteInvitedUser'
import { getWorkspaceLink } from 'utils'
import {
  useGetCurrentWorkspaceGuests,
  useGetCurrentWorkspace,
  useGetCurrentWorkspaceInvitedUsers,
  useGetCurrentPlan
} from '~workspace/queries/useGetWorkspaceById'
import { useUpdateMemberSubscription } from '~workspace/queries/useUpdateMemberSubscription'
import { GuestExceedDialog as Dialog } from 'ui-components'
import { useUpgradeToMember } from '~workspace/queries/useUpgradeToMember'
import { InvitedUser, Member } from '~workspace/types/__generated/gql/graphql'
import { useEffect, useState } from 'react'

export const GuestList = () => {
  const [open, setOpen] = useState(false)
  const [workspaceLink, setWorkspaceLink] = useState('')
  const { query, replace } = useRouter()
  const isWorkspaceOwner = useIsWorkspaceOwner()
  const { data: workspace } = useGetCurrentWorkspace()
  const guests = useGetCurrentWorkspaceGuests()
  const invitedUsers = useGetCurrentWorkspaceInvitedUsers()
  const deleteInvitedUser = useDeleteInvitedUser()
  const updateMemberSubscription = useUpdateMemberSubscription()
  const upgradeToMember = useUpgradeToMember()
  const plan = useGetCurrentPlan()

  useEffect(() => {
    if (workspace)
      setWorkspaceLink(
        getWorkspaceLink({
          workspaceId: workspace.id,
          workspaceName: workspace.name,
          tab:
            plan?.name === PLANS.free.name
              ? WORKSPACE_TAB.UPGRADE
              : WORKSPACE_TAB.BILLING
        })
      )
    if (plan && guests.length > plan.guestsLimit) {
      setOpen(true)
    }
  }, [guests, plan, workspace])

  const guestInvitedUsers = invitedUsers?.filter(
    (invitedUser) => invitedUser.role === 'guest'
  )

  const handleRemoveGuestConfirm = async (userId) => {
    await deleteInvitedUser.mutateAsync({
      userId,
      workspaceId: query.workspaceId!.toString()
    })
  }

  const handleUpgradeToMemberConfirm = async (userId) => {
    await upgradeToMember.mutateAsync({
      userId,
      workspaceId: query.workspaceId!.toString()
    })

    if (workspace?.id)
      await updateMemberSubscription.mutateAsync({ workspaceId: workspace?.id })
  }

  const handlePrimaryClick = () => {
    replace(workspaceLink)
  }

  return (
    <>
      <View
        canRemoveGuest={isWorkspaceOwner}
        canUpgradeToMember={isWorkspaceOwner}
        isRemovingGuest={deleteInvitedUser.isPending}
        guests={guests as Member[]}
        invitedUsers={guestInvitedUsers as InvitedUser[]}
        onRemoveGuestConfirm={handleRemoveGuestConfirm}
        onUpgradeToMemberConfirm={handleUpgradeToMemberConfirm}
      />
      <Dialog
        limits={plan?.guestsLimit || 0}
        open={open}
        onPrimaryClick={handlePrimaryClick}
      />
    </>
  )
}
